import {combineReducers} from "redux";
import {reducer as formReducer} from "redux-form";

import accountReducer from "./accountReducer";
import addressReducer from "./addressReducer";
import announcementReducer from "./announcementReducer";
import invoiceReducer from "./approveReturnInvoice";
import brandReducer from "./brandReducer";
import campaignReducer from "./campaignReducer";
import cancelReasonReducer from "./cancelReasonReducer";
import capacityTimeslotReducer from "./capacityTimeSlotReducer";
import categoryReducer from "./categoryReducer";
import centralUIConfigReducer from "./centralUIConfigReducer";
import cmsReducer from "./cmsReducer";
import codReportReducer from "./codReportReducer";
import commentReducer from "./commentReducer";
import counterReducer from "./counterReducer";
import couponReducer from "./couponReducer";
import customerFeeReducer from "./customerFeeReducer";
import customerReducer from "./customerReducer";
import distributeOrderReducer from "./distributeOrderReducer";
import itemAttribute from "./itemAttributeReducer";
import itemManagementReducer from "./itemManagementReducer";
import languageReducer from "./languageReducer";
import languageSettingReducer from "./languageSettingReducer";
import logReducer from "./logReducer";
import massuploadReducer from "./massuploadReducer";
import mediaReducer from "./mediaReducer";
import metaDataReducer from "./metaDataReducer";
import multiLanguageReducer from "./multiLanguageReducer";
import notificationsReducer from "./notificationsReducer";
import operationReducer from "./operationReducer";
import orderNotificationReducer from "./orderNotificationReducer";
import orderReducer from "./orderReducer";
import orderVetificationReducer from "./orderVerificationReducer";
import packageReducer from "./packageReducer";
import paymentTransactionReducer from "./paymentTransactionReducer";
import permissionReducer from "./permissionReducer";
import picklistReducer from "./picklistReducer";
import platformReducer from "./platformReducer";
import policyReducer from "./policyReducer";
import productReducer from "./productReducer";
import promotionReducer from "./promotionReducer";
import reasonReducer from "./reasonReducer";
import reportStockReducer from "./reportStockReducer";
import reviewReducer from "./reviewReducer";
import roleReducer from "./roleReducer";
import sellerReducer from "./sellerReducer";
import shipperReducer from "./shipperReducer";
import skuReducer from "./skuReducer";
import stationReducer from "./stationReducer";
import stockReducer from "./stockReducer";
import supplierReducer from "./supplierReducer";
import tagReducer from "./tagReducer";
import ticketReducer from "./ticketReducer";
import userReducer from "./userReducer";
import variantReducer from "./variantReducer";
import waybillReducer from "./waybillReducer";

const appReducer = combineReducers({
  returnInvoices: invoiceReducer,
  multiLanguage: multiLanguageReducer,
  account: accountReducer,
  notifications: notificationsReducer,
  notification: orderNotificationReducer,
  form: formReducer,
  user: userReducer,
  reason: reasonReducer,
  cancelReason: cancelReasonReducer,
  operation: operationReducer,
  cod: codReportReducer,
  role: roleReducer,
  permission: permissionReducer,
  platform: platformReducer,
  address: addressReducer,
  centralUIConfig: centralUIConfigReducer,
  supplier: supplierReducer,
  station: stationReducer,
  auditLog: logReducer,
  comment: commentReducer,
  review: reviewReducer,
  order: orderReducer,
  distributeOrder: distributeOrderReducer,
  paymentTransaction: paymentTransactionReducer,
  language: languageReducer,
  language_setting: languageSettingReducer,
  itemAttribute,
  item: itemManagementReducer,
  category: categoryReducer,
  media: mediaReducer,
  policy: policyReducer,
  stock: stockReducer,
  capacity_timeslot: capacityTimeslotReducer,
  customer: customerReducer,
  sku: skuReducer,
  customer_fee: customerFeeReducer,
  picklist: picklistReducer,
  variant: variantReducer,
  massuploadResponse: massuploadReducer,
  promotion: promotionReducer,
  product: productReducer,
  orderVetification: orderVetificationReducer,
  ticket: ticketReducer,
  announcement: announcementReducer,
  counter: counterReducer,
  package: packageReducer,
  metadata: metaDataReducer,
  tag: tagReducer,
  brand: brandReducer,
  coupon: couponReducer,
  reportStock: reportStockReducer,
  waybill: waybillReducer,
  seller: sellerReducer,
  cms: cmsReducer,
  campaign: campaignReducer,
  shipper: shipperReducer
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_STATE_WHEN_LOGOUT") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
